module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.actualBundle.cars.length == 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.textNoEVCarRegistered[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-w300 push"
  }, [_vm._v(_vm._s(_vm.labelTopPage[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelTimeSelectorTitle[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('range-picker', {
    on: {
      "refresh": _vm.refreshData
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCar),
      expression: "selectedCar"
    }],
    staticClass: "push",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCar = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.actualBundle.cars), function(charge, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(_vm.actualBundle.cars[index].ReferenceName))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "280px",
      "src": _vm._f("s3Image")(("cars/" + (_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.carPictureFile)))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('div', {
    staticClass: "block block-rounded block-bordered"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success text-center push"
  }, [_c('div', {
    staticClass: "font-w400 text-white animated fadeIn"
  }, [_vm._v(_vm._s(_vm.labelCarTotalSavings[_vm.actualLanguage]))]), _vm._v(" "), _c('span', {
    staticClass: "h2 font-w600 font-s30 text-white animated fadeIn"
  }, [_vm._v(_vm._s(_vm._f("toCurrency")(_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.lifeTimeMoneySavings)))])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted animated fadeIn text-center"
  }, [_c('small', [_c('i', {
    staticClass: "si si-calendar"
  }), _vm._v(" " + _vm._s(_vm.labelCarTotalSavingsStartDate[_vm.actualLanguage]) + " " + _vm._s(_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.startingDate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('div', {
    staticClass: "block block-rounded block-bordered"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-success text-center push"
  }, [_c('div', {
    staticClass: "font-w400 text-white animated fadeIn"
  }, [_vm._v(_vm._s(_vm.labelCarTotalGreenSavings[_vm.actualLanguage]))]), _vm._v(" "), _c('span', {
    staticClass: "h2 font-w600 font-s30 text-white animated fadeIn"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.lifeTimeGreenGazSavings)) + " T CO2")])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted animated fadeIn text-center"
  }, [_c('small', [_c('i', {
    staticClass: "si si-calendar"
  }), _vm._v(" " + _vm._s(_vm.labelCarTotalSavingsStartDate[_vm.actualLanguage]) + " " + _vm._s(_vm.actualBundle.cars[_vm.selectedCar].CarData.carInfo.startingDate))])])])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h3', {
    staticClass: "content-heading"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryTitle[_vm.actualLanguage]) + " "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm._f("formatDate")(_vm.startDate)) + " " + _vm._s(_vm.labelPeriodSummaryTitle2[_vm.actualLanguage]) + " " + _vm._s(_vm._f("formatDate")(_vm.endDate)) + ")")])])])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "row-flex row-flex__5 dashboar-month-data"
  }, [_c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryChargeCosts[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.totalCost)) + " "), _c('span', {
    staticClass: "h2 text-muted"
  }, [_vm._v("$")])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryChargeTime[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("toMinutes")(_vm.totalChargeTime)))])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-download fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryPower[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.totalEnergy)) + " "), _c('span', {
    staticClass: "h2 text-muted"
  }, [_vm._v("kWh")])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryGazSaving[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("toCurrency")(_vm.totalMoneySaving)) + " "), _c('span', {
    staticClass: "h2 text-muted"
  })])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-content text-center"
  }, [_c('i', {
    staticClass: "fa fa-leaf fa-3x text-success"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "h5 text-muted"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryGreenGazSaving[_vm.actualLanguage]))])]), _vm._v(" "), _c('p', {
    staticClass: "h1 font-w700"
  }, [_vm._v(_vm._s(_vm._f("round")(_vm.totalgreenGazSaving)) + " "), _c('span', {
    staticClass: "h2 text-muted"
  }, [_vm._v(" T CO2")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryGraphCharge[_vm.actualLanguage]) + " "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm._f("formatDate")(_vm.startDate)) + " au " + _vm._s(_vm._f("formatDate")(_vm.endDate)) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [(_vm.chargeMonthChartData) ? _c('bar-chart', {
    attrs: {
      "chartData": _vm.chargeMonthChartData
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryGraphCosts[_vm.actualLanguage]) + " "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm._f("formatDate")(_vm.startDate)) + " au " + _vm._s(_vm._f("formatDate")(_vm.endDate)) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [(_vm.costMonthChartData) ? _c('bar-chart', {
    attrs: {
      "chartData": _vm.costMonthChartData
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.cars.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelPeriodSummaryTableTitle[_vm.actualLanguage]) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table remove-margin-b font-s13"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColStart[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColEnd[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColEnergy[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColCost[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColSaving[_vm.actualLanguage]))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.labelPeriodSummaryTableColGreenSaving[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.carChargeList), function(charge) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600 text-muted"
    }, [_vm._v(_vm._s(charge.startTime))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs text-muted "
    }, [_vm._v(_vm._s(charge.endTime))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(charge.energy)))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(charge.cost)))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(charge.moneySaving)))]), _vm._v(" "), _c('td', {
      staticClass: "font-w600 text-success "
    }, [_vm._v(_vm._s(_vm._f("round")(charge.greenGazSaving)))])])
  }), 0)])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4edc808f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ports/Home.vue
// module id = 1529
// module chunks = 4